import * as React from 'react';
import { registerComponent, withProgressiveHydration } from '@avensia/excite';
import { styled } from '@glitz/react';
import { createMinLargeViewportDecorator, createMaxSmallViewportDecorator } from 'webapp/viewport';
import { Block, desktopEdgeMarginDecorator, maxContentNormalWidthDecorator } from 'webapp/components/page-layout';
import TrustpilotWidget from 'webapp/components/trustpilot-widget';

export const RegisteredTrustpilotBlock = registerComponent<NordicNest.Api.TrustpilotBlock>(
  withProgressiveHydration(TrustpilotBlock),
);

export default function TrustpilotBlock(props: NordicNest.Api.TrustpilotBlock) {
  return (
    <Base>
      <TrustpilotWidget widgetHtml={props.widgetHtml} scriptUrl={props.scriptUrl} />
    </Base>
  );
}

const Base = styled(
  Block,
  maxContentNormalWidthDecorator,
  desktopEdgeMarginDecorator,
  createMinLargeViewportDecorator({
    padding: {
      y: t => t.spacing.xxl,
    },
  }),
  createMaxSmallViewportDecorator({
    padding: {
      y: t => t.spacing.l,
    },
  }),
);
